import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from "@chakra-ui/react";
import { IoClose } from "react-icons/io5";
import { FaFileDownload } from "react-icons/fa";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { downloadPdf } from "components/allForm/InvoiceTemplate/uttils/pdfUtiils";
import DefaultInvoiceTemplate from "components/allForm/InvoiceTemplate/templates/default";
import InvoiceTemplateOne from "components/allForm/InvoiceTemplate/templates/templateOne";
import InvoiceTemplateTwo from "components/allForm/InvoiceTemplate/templates/templateTwo";
import InvoiceTemplateThree from "components/allForm/InvoiceTemplate/templates/templateThree";
import useSalesInvoiceModule from "hooks/organizaton/useSalesInvoiceModule";
import { calculateGstAmount,calculateTotalQuantityAndAmount } from "components/allForm/PurchaseOrder/helperFunction";
import { allCurrency } from "components/allForm/SalesItem/currencyJson";
import { getInvoicePdf } from "api/invoice";
import useOrganizationData from "hooks/organizaton/useOrganization";
import { GetCountries,GetState,GetCity, } from 'react-country-state-city';
import useClientDetails from "components/allForm/InvoiceTemplate/api/useClientData";
import moment from "moment";
import useBankDetails from "components/allForm/InvoiceTemplate/api/useOrganizationBankData";
import { convertAmountToWords } from "components/allForm/PaymentMode/helper";
import { useToasts } from "react-toast-notifications";

const SalesInvoicePdf = ({
  isOpen,
  onClose,
  isProforma,
  expenseData,
  itemList,
  moduleId,
  isPreview,
}) => {
  const [loading, setLoading] = useState(true);
  const {salesModule} = useSalesInvoiceModule();
  const { organizationData, logoUrl, loading: isOrgLoading } = useOrganizationData();
  const {clientDetail, loading: isClientLoading} = useClientDetails(expenseData?.clId?._id);
  const [addresses,setAddresses] = useState();
  const {addToast} = useToasts();
  
  const selectedBankDetails = useMemo(() => {
    if (["AutomatedBank", "OragnizationBank"].includes(expenseData?.selectedBankIdModel) && expenseData?.selectedBankId) {
      if (expenseData?.selectedBankIdModel === "AutomatedBank") {
        return {
          bankName: expenseData?.selectedBankId?.bnk?.name,
          branchName: expenseData?.selectedBankId?.bnk?.bch,
          accountNumber:expenseData?.selectedBankId?.bnk?.acNo,
          ifsc: expenseData?.selectedBankId?.bnk?.ifc,
          swift: expenseData?.selectedBankId?.bnk?.swt,
        }
      }
      return {
        bankName: expenseData?.selectedBankId?.bnk,
        branchName: expenseData?.selectedBankId?.bch,
        accountNumber:expenseData?.selectedBankId?.acNo,
        ifsc: expenseData?.selectedBankId?.ifc,
        swift: expenseData?.selectedBankId?.swiftCode
      }
    }
  },[expenseData?.selectedBankId, expenseData?.selectedBankIdModel])

  const orgBank = useBankDetails();
  const bankDetails = useMemo(()=>{
    if(organizationData?.isBnk){
      if(organizationData?.bnk?.typ === 'auto'){
        return orgBank
      }
      else{
        return organizationData?.bnk;
      }
    }
    return {}
  },[orgBank,organizationData])

  const templateId = useMemo(() => {
    if (salesModule) {
      const module = salesModule.find(module => module._id === moduleId);
      
      if (module && module?.tmpId) {
        return module?.tmpId;
      } 
      return "DefaultTemplate"
    }
  }, [salesModule, moduleId]);
  const templates = {
    DefaultTemplate: DefaultInvoiceTemplate,
    Template1: InvoiceTemplateOne,
    Template2: InvoiceTemplateTwo,
    Template3: InvoiceTemplateThree

  };
  const SelectedTemplate = templates[templateId] || DefaultInvoiceTemplate;

  const invoiceDateFormatted = useMemo(()=>{
    if(isProforma && expenseData?.pfiDt){
      return moment(expenseData?.pfiDt).format("DD-MMM-yyyy")
    }
    else if(expenseData?.inDt){
      return moment(expenseData?.inDt).format("DD-MMM-yyyy")
    }
    else{
      return "NA"
    }
  },[isProforma,expenseData])
  
  const dueDateFormatted = useMemo(()=>{
    if(isProforma && expenseData?.pfiDuDt){
      return moment(expenseData.pfiDuDt).format("DD-MMM-yyyy")
    }
    else if(expenseData.duDt){
      return moment(expenseData.duDt).format("DD-MMM-yyyy")
    }
    else{
      return "NA"
    }
  },[isProforma,expenseData])

  const total = useMemo(()=>{
    if(itemList && itemList?.length){
      const totalGstAmount = calculateGstAmount(itemList);
      const totalValue = calculateTotalQuantityAndAmount(itemList);
      return {
        amt: totalValue?.amt,
        gstAmt:totalGstAmount
      }
    }
    return {
      amt: 0,
      gstAmt:0
    }
  },[itemList]);

  const totalPaymentAmount = useMemo(()=>{
    const totalAmt = Number(total?.amt) + Number(expenseData?.adjAmt || 0) + Number(expenseData?.shpCrg || 0) + Number(total?.gstAmt || 0);
    return totalAmt
  },[total,expenseData])

  const gst = useMemo(()=>{
    if(expenseData?.gstRc && expenseData?.gstRc?.length){
      const gstAmount = expenseData?.gstRc[0]?.amt;
      const gstType = gstAmount?.i ? 'IGST' : "CGST & SGST"
      return {
        type:gstType,
        gstAmt:gstAmount,
        gstNumber:expenseData?.gstRc[0]?.gstNo
      }
    }
    return {
      type:"IGST",
      gstAmt:{
        c:0,
        s:0,
        i:0
      },
      gstNumber:"NA"
    }
  },[expenseData])

  const currency = useMemo(()=>{
    const curr = allCurrency.find((opt)=>opt.code === (expenseData?.inCr || "INR"))
    return curr;
  },[expenseData?.inCr])

  const terms = useMemo(()=>{
    if (expenseData?.tDays === -1) {
      const inDt = isProforma ? expenseData?.pfiDt : expenseData?.inDt;
      const duDt = isProforma ? expenseData?.pfiDuDt : expenseData?.duDt;
      if (duDt && inDt) {
        const diffDays = moment(duDt).diff(inDt, 'days')
        if (!isNaN(diffDays)) {
          return {
            name: `Net ${diffDays}`
          }
        }
      }
      return {
        name: "Custom",
      }
    }
    const module = salesModule.find(module => module._id === moduleId);
    const terms = module?.pyTrms || [];
    const selected = terms?.find((t)=>t.days === expenseData?.tDays);
    return selected;

  },[expenseData,salesModule,moduleId])

  const fetchAddressDetails = async (...addresses) => {
    const cache = {
      countries: null,
      states: {},
      cities: {},
    };

    cache.countries = await GetCountries() || [];

    return Promise.all(
      addresses.map(async (address) => {
        if (!address) return {}
        const countryId = address?.ctr || 101;
        const stateId = address?.st || null;
        const cityId = address?.ct || null;

        const country =
          cache.countries.find(c => c.id === countryId);

        if (!cache.states[countryId]) {
          cache.states[countryId] = GetState(countryId) || [];
        }
        const state =
          (await cache.states[countryId]).find(s => s.id === stateId);

        const cityKey = `${countryId}_${stateId}`;
        if (stateId && !cache.cities[cityKey]) {
          cache.cities[cityKey] = GetCity(countryId, stateId) || [];
        }
        const city =
          (await cache.cities[cityKey])?.find(c => c.id === cityId);

        return {
          ...address,
          countryName: country?.name || "",
          stateName: state?.name || "",
          cityName: city?.name || ""
        };
      })
    );
  };

  const fetchAndSetAddresses=useCallback(async()=> {
    if (isClientLoading || isOrgLoading) return;
    setLoading(true)
    try {
      const [orgAddress, clientAddress, clientShippingAddress] =
        await fetchAddressDetails(
          organizationData?.add,
          clientDetail?.add,
          clientDetail?.spAd,
        );
      setAddresses({orgAddress, clientAddress, clientShippingAddress});
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClientLoading, isOrgLoading])

  useEffect(() => {
    fetchAndSetAddresses();
  }, [fetchAndSetAddresses]);

  const invoiceTemplateProps = {
    organizationData: {
      ...organizationData,
      tc: isProforma ? organizationData?.pfTc : organizationData?.stc,
    },
    logoUrl,
    clientDetail,
    title: isProforma ? "Proforma Invoice" : "Tax Invoice",
  
    idNo: InvoiceNumberFormate(
      isProforma ? expenseData?.pfiNo : expenseData?.inNo
    ),
  
    clientId: expenseData?.clId?._id,
    clientGst: gst?.gstNumber,
  
    invoice: {
      heading: isProforma ? "Document No" : "Invoice Number",
      value: InvoiceNumberFormate(
        isProforma ? expenseData?.pfiNo : expenseData?.inNo
      ),
    },
  
    invoiceDate: {
      heading: "Invoice Date",
      value: invoiceDateFormatted,
    },
  
    dueDate: {
      heading: "Due Date",
      value: dueDateFormatted,
    },
  
    invoiceTerms: {
      heading: "Terms",
      value: terms?.name || "Due on Receipt",
    },
  
    invoiceCurrency: {
      heading: "Currency",
      value: currency?.code || "INR",
    },
  
    invSub: {
      heading: "Subject",
      value: expenseData?.invSub,
    },
  
    itemList,
    currency,
  
    gst: {
      type: gst?.type,
      amount: gst?.gstAmt,
    },
  
    totalAmount: total?.amt,
    total,
  
    freightCharge: expenseData?.shpCrg,
  
    adjustment: {
      heading: expenseData?.adjLab || "Adjustment",
      value: expenseData?.adjAmt,
    },
  
    customerNotes: expenseData?.cNts,
    totalPaymentAmount,

    ...addresses,
  
    isProforma,
    bankDetails,
    templateId,
    amountInWords: convertAmountToWords(totalPaymentAmount || 0),
    selectedBankDetails,
  };

  const handlePdf = async () => {
    try {
      const {orgAddress, clientAddress, clientShippingAddress} = addresses || {};
      
      await getInvoicePdf({
        ...invoiceTemplateProps,
        organizationData: {
          ...invoiceTemplateProps.organizationData,
          add: orgAddress,
        },
        clientDetail: {
          ...invoiceTemplateProps.clientDetail,
          add: clientAddress,
          spAd: clientShippingAddress,
        },
        invoiceDate: {
          ...invoiceTemplateProps.invoiceDate,
          value: invoiceDateFormatted,
        },
      },  invoiceTemplateProps?.idNo && `${invoiceTemplateProps?.idNo}.pdf`);
    } catch (error) {
      console.error(error)
      addToast('Error downloading document', {appearance: 'error'});
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="modal-main" size="xl">
      <ModalOverlay />
      <ModalContent
        className="add-form-modal-content"
        top="0"
        margin="0 auto"
        bottom="0"
      >
        <div className="fixed-header  mt-0">
          <Box className="payment-template">
            <Tooltip
              label="Close"
              placement="bottom"
              hasArrow
              className="common-tooltip"
            >
              <button className="close-btn" onClick={onClose}>
                <IoClose />
              </button>
            </Tooltip>
            {!isPreview && (
              <Tooltip
                label="Download"
                placement="bottom"
                hasArrow
                className="common-tooltip"
              >
                <button onClick={handlePdf} disabled={loading} title={loading ? "Please wait while data is loading" : undefined} className="pdf-downlode-icon">
                  <FaFileDownload />
                </button>
              </Tooltip>
            )}
          </Box>
        </div>
        <ModalBody>
            <Box>
              {loading ? (
                <SpinnerLoader />
              ) : (
                <SelectedTemplate {...invoiceTemplateProps} />
              )}
            </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SalesInvoicePdf;
